import styled from "@emotion/styled";
import MuiAccordionDetails from "@mui/material/AccordionDetails";

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: 0,
  // padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
  display: "flex",
  alignItems: "center",
  gap: "15px",
  "&:last-of-type": {
    padding: 0,
  },
}));
export default AccordionDetails;
